import React from "react";

const Loading = () => {
  return (
    <div>
      <div className={`loading-main`}>
        <div className="loading-outer">
          <div className="container">
            <div  className="line bg-primary/10"></div>
            <div className="line d1 bg-primary"></div>
            <div  className="line d2 bg-primary/10"></div>
            <div className="line d3 bg-primary"></div>
            <div  className="line d4 bg-primary/10"></div>
            <div className="line d5 bg-primary"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
